import { render, staticRenderFns } from "./xiaoshulin.vue?vue&type=template&id=6b8b85bb&scoped=true&"
import script from "./xiaoshulin.vue?vue&type=script&lang=js&"
export * from "./xiaoshulin.vue?vue&type=script&lang=js&"
import style0 from "./xiaoshulin.vue?vue&type=style&index=0&id=6b8b85bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b8b85bb",
  null
  
)

export default component.exports